import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If the URL has a hash (e.g. /about#team), smooth-scroll to that section.
    // Retry briefly, since lazy-loaded pages may not have rendered yet.
    if (hash) {
      const id = hash.replace('#', '');
      let tries = 0;
      const HEADER_OFFSET = 110; // clears the sticky navbar
      const tryScroll = () => {
        const el = document.getElementById(id);
        if (el) {
          const y = el.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET;
          window.scrollTo({ top: y, behavior: 'smooth' });
        } else if (tries < 20) {
          tries += 1;
          setTimeout(tryScroll, 100);
        }
      };
      tryScroll();
      return;
    }
    // No hash — jump to top on route change.
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname, hash]);

  return null;
}